<script>
import api from "@/axios";
import Loader from "../components/loader.vue";
import Layout from '../../layouts/main.vue'
import PageHeader from '@/components/page-header.vue'
import appConfig from "@/app.config.json";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/transf_anim.json'
import { pedidosChart1, pedidosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import DropZone from "@/components/widgets/dropZone.vue";
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import { exportDataGrid } from 'devextreme/excel_exporter';
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import DxButton from "devextreme-vue/button";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import CustomStore from "devextreme/data/custom_store";
import {Workbook} from "exceljs";
import {saveAs} from "file-saver-es";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Movimentos de Ajuste de Estoque",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: {DropZone, Layout, PageHeader, Loader, Vue3Lottie,
    DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations},

  data() {
    return {
      animationJson,
      title: 'Movimentos de Ajuste de Estoque',
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Movimentos de Ajuste de Estoque',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      movajtList: null,
      pesqTextFilter: '',
      statusFilter: 'T',

      pedChart1: pedidosChart1,
      pedChart2: pedidosChart2,
      showModalImportarMovAjt: false,
      submittedAnexo: false,
      showPendenteModalImport: false,

      dataList: null,
      totalList: 0,
      updating: false,

      selectedItems: 0,

      exibEmit: true,
      exibDest: false,
      exibAmbos: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,
    }
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted movajuste-list_0')
    this.atualizaDataList()
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop, v$: useVuelidate()};
  },

  methods: {

    atualizarItensSelecionados(e) {
      this.selectedItems = e.selectedRowsData.length;
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    baixarModeloImportacao(){
      api.get(`${getBaseUrl()}api/baixamodelomovajt`, {
        responseType: 'blob'
      }).then(response => {
        console.log('response.data')
        console.log(response.data)

        //Criando link temporário para realizar download
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'econopro_modelo_tabela_importa_ajuste_v1.xlsx'
        link.click()

        //limpando URL do objeto - limpando memória
        window.URL.revokeObjectURL(link)
      }).catch((error) => {
        console.log('erro ao baixar arquivo')
        console.log(error)
      })
    },

    selectedFile(){
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]

      let arquivoEmMegas = (this.dropzoneFile.size / 1000000)
      if(arquivoEmMegas > 2){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Panilha não pode passar 2 megas!',
          showConfirmButton: false,
          timer: 4000
        }).then(() => {
          this.showModalImportarMovAjt = false
        })
      }
    },

    atualizaPagina(){
      window.locale.reload()
    },

    confirmarImportacaoMovAjt(){
      this.submittedAnexo = true
      if (this.dropzoneFile.name){
        this.showModalAtuLogo = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)

        let arquivoEmMegas = (arquivo.size / 1000000)

        if(arquivoEmMegas > 2) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Panilha não pode passar 2 megas!',
            showConfirmButton: false,
            timer: 4000
          }).then(() => {
            this.showModalImportarMovAjt = false
            this.dropzoneFile = ""
          })
        }else{
          let formData = new FormData()
          formData.append("iddata", this.idData)
          formData.append("tipoUpload", this.tipoUpload)
          formData.append("filename", arquivo.name)
          formData.append("file", arquivo)

          this.showModalImportarMovAjt = false
          this.showPendenteModalImport = true

          api.post(`${getBaseUrl()}api/importmovajt`,formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((res) => {
            console.log('then axios importmovajt')
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Planilha processada com sucesso!",
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.downloadErrorLog(res.data.erros)

                this.showPendenteModalImport = false
                this.$router.push(`/movajuste/editar/${res.data.movajt_id}`)
              })
            }else{
              let retorno = res.data

              if(retorno.message){
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Processamento falhou!",
                  text: res.data.message,
                  showConfirmButton: false,
                  timer: 5000
                }).then(() => {
                  this.dropzoneFile = ""
                  this.showPendenteModalImport = false
                })
              }else{
                this.downloadErrorLog(res.data.erros)
                console.log('montando texto erros')

                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: "Processamento falhou!",
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  this.showPendenteModalImport = false
                  this.dropzoneFile = ""
                  this.atualizaDataList()
                })
              }
            }
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof  erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.showPendenteModalImport = false
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }
    },

    downloadErrorLog(errors) {
      if (!errors || errors.length === 0) {
        console.error("Nenhum erro encontrado para salvar.");
        return;
      }

      // Converte o array de erros em um texto formatado
      const errorText = errors.map(err => `Linha ${err.linha}: ${err.erro}`).join("\n");

      // Cria um Blob com o conteúdo do erro
      const blob = new Blob([errorText], { type: "text/plain" });

      // Cria uma URL temporária para o Blob
      const url = URL.createObjectURL(blob);

      // Cria um link para download
      const a = document.createElement("a");
      a.href = url;
      a.download = "erros.txt"; // Nome do arquivo
      document.body.appendChild(a);
      a.click(); // Aciona o clique para baixar
      document.body.removeChild(a); // Remove o link após o download

      // Revoga a URL com um pequeno delay
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 1000);
    },


    exportExcel(){
      console.log('exportExcel')
      const data = this.movajtList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')


      this.title = `(${e.component.totalCount()}) Movimentos de Ajuste: ${dtIniFormated} - ${dtFimFormated}`

    },

    atualizaDataList(){
      console.log('atualizaDataList_movAjute')

      this.loadingList = true

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const exibEmit = this.exibEmit
      const exibDest = this.exibDest
      const exibAmbos = this.exibAmbos
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'ee': exibEmit,
            'ed': exibDest,
            'ea': exibAmbos,
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movajts`, {
            params: paramsReq
          }).then(response => {
            console.log('then axios')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })

      // this.loadingList = true
      // api.get(`${getBaseUrl()}api/movajts`, {
      //   params: {
      //     'q': this.pesqTextFilter,
      //     's': this.statusFilter
      //   }
      // }).then((res) => {
      //   console.log('then axios')
      //   console.log(res.data[0])
      //   this.movajtList = res.data[0]
      //   this.title = `(${this.movajtList.length}) Movimentos de Ajuste`
      this.loadingList = false
      this.loadingGraph = false
      // });
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)

      const routeData = this.$router.resolve(`/movajuste/editar/${row.data.id}`)
      window.open(routeData.href, '_blank')

    },

    nomeStatus(e){
      let result = 'Não Definido'
      switch (e.value) {
        case 'FA':
          result = 'Faturado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CO':
          result = 'Confirmado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'FA':
              corStatus = 'rgb(77,179,53)'
              break
            case 'EL':
              corStatus = 'rgb(239,179,75)'
              break
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CO':
              corStatus = 'rgb(5,120,236)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    criarNovoAjuste() {
      console.log('Novo Ajuste')
      this.$router.push(`/movajuste/editar/0`)
      // this.updating = !this.updating
    },

    importarAjustes() {
      console.log('importar Ajuste')
      this.showModalImportarMovAjt = true;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatarTipo(value){
      if(value == '01'){
        return 'Entrada'
      } else {
        return 'Saída'
      }
    }
  },

}
</script>

<template>
  <Layout>

    <span class="float-end" style="position: absolute; top: 18px; right: 230px;">
      <Vue3Lottie :animationData="animationJson" :height="300" :width="300" />
    </span>

    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div class="mt-2">

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              icon="plus"
              hint="Criar Novo Ajuste"
              text="Novo Ajuste"
              :on-click="criarNovoAjuste"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="import"
              hint="Importar Ajustes"
              text="Importar Ajustes"
              :on-click="importarAjustes"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-3">
      <p><strong>Itens Selecionados: {{ selectedItems }}</strong></p>
    </div>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting"
          @selection-changed="atualizarItensSelecionados">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strProdutosList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="center"
            :filter-operations="['contains','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="empr_nome"
            caption="Empresa Nome"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="empr_cnpj"
            caption="Empresa CNPJ"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="codigo"
            caption="Código"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tipo"
            caption="Tipo"
            data-type="text"
            alignment="center"
            :format="formatarTipo"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="created_by"
            caption="Usuário"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Data"
            alignment="center"
            data-type="datetime"
            :format="formatDateTime"
            :filter-operations="['contains', '=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="valorbrt"
            caption="Valor Brt."
            alignment="center"
            :format="formatDecimal"
            :filter-operations="['contains','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="valorliq"
            caption="Valor Líq."
            alignment="center"
            :format="formatDecimal"
            :filter-operations="['contains','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>

    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Anual</h4>

            <apexchart
                class="apex-charts"
                height="350"
                type="line"
                dir="ltr"
                :series="pedChart1.series"
                :options="pedChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Fornecedores</h4>

            <apexchart
                class="apex-charts"
                height="320"
                type="pie"
                dir="ltr"
                :series="pedChart2.series"
                :options="pedChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Upload Inventário" v-model="showModalImportarMovAjt" hide-footer>
      <div class="row">
        <div class="card-body d-flex justify-content-center">
          <button class="btn btn-info" @click="baixarModeloImportacao">
            <i class="bx bx-download me-1 text-end"></i> Baixar modelo importação
          </button>
        </div>
      </div>

      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalImportarMovAjt = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarImportacaoMovAjt">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showPendenteModalImport"
        size="md"
        title-class="font-12"
        title="Só um momento!"
        hide-footer
    >
      <h4>Estamos Processando sua Planilha...</h4>
    </b-modal>

  </Layout>
</template>
